import React, { Fragment, createContext, useState } from "react";
import Seo from "./seo";
import Loader from "./loader";
import useAuthCheck from "./auth/userCheck";
import root from "window-or-global";

export const AuthContext = createContext({});
export const GlobalAlertContext = createContext({})

export default function Main ({ children }) {
    const description = "";
    const {currentUser, isLoggedIn, isLoading: userDataLoading, refetchUserData, setIsLoggedIn} = useAuthCheck();
    const [alertValue, setAlertValue] = useState(null); // -- { message: "alert message", variant: "primary" }

    if (userDataLoading || !root.document) {
        return <Loader/>;
    }

    return (
        <Fragment>
            <AuthContext.Provider value={{currentUser, isLoggedIn, userDataLoading, refetchUserData, setIsLoggedIn}}>
                <GlobalAlertContext.Provider value={{alertValue, setAlertValue}}>
                    <Seo title={`Elaris Connect`}>
                        <meta name="description" content={`Elaris Connect VISP Portal`}/>
                    </Seo>
                    {children}
                </GlobalAlertContext.Provider>
            </AuthContext.Provider>
        </Fragment>
    )
}